import React from "react";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../api/ApiSettings";

const initialState = {
    quantityCorrectionsProposals: [],
    selectedQuantity: null
}
export const getQuantityCorrectionsProposals = createAsyncThunk('complaint/getQuantityCorrectionsProposals', async()=>{
    const response = await fetch(`${API_URL}complaint/getQuantityCorrectionsProposals`, null)
    const data = await response.json(); 
    return data;
})


export const quantityCorrectionsProposalsSlice = createSlice({
    name: 'quantity',
    initialState,
    reducers:{ 
        correctionsProposals: (state,action)=>{
            state.quantityCorrectionsProposals = action.payload;
        }},
    
  extraReducers: {
   
    [getQuantityCorrectionsProposals.fulfilled]: (state, action) => {
      state.quantityCorrectionsProposals = action.payload;
      state.selectedQuantity = action.payload[0];
    },
   
  },
});

export const {correctionsProposals} = quantityCorrectionsProposalsSlice.actions;
export default quantityCorrectionsProposalsSlice.reducer;